import { createFileRoute } from "@tanstack/react-router";
import { AdminGuard } from "@/components/AdminGuard";
import { pageTitle } from "@/lib/brand";
import { parseDiscoveryRouteSearch } from "@/discovery/presentation";
import { DiscoveryJourney } from "@/components/DiscoveryJourney";

export const Route = createFileRoute("/discovery/$publicCustomerSlug")({
  validateSearch: parseDiscoveryRouteSearch,
  head: () => ({
    meta: [
      { title: pageTitle("Kitchen project estimate") },
      {
        name: "description",
        content:
          "Answer five helpful questions and see a preliminary kitchen project range. No phone number or email required.",
      },
      {
        property: "og:title",
        content: pageTitle("Kitchen project estimate"),
      },
      {
        property: "og:description",
        content:
          "A guided way to understand a kitchen project direction and realistic preliminary range.",
      },
    ],
  }),
  component: DiscoveryAccess,
});

function DiscoveryAccess() {
  const { adminView } = Route.useSearch();
  return adminView ? (
    <AdminGuard>
      <Discovery key="admin" adminView />
    </AdminGuard>
  ) : (
    <Discovery key="visitor" />
  );
}

function Discovery({ adminView = false }: { adminView?: boolean }) {
  const { publicCustomerSlug } = Route.useParams();
  const search = Route.useSearch();
  return (
    <DiscoveryJourney
      publicCustomerSlug={publicCustomerSlug}
      search={search}
      adminView={adminView}
    />
  );
}
